import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbProps {
  items?: { label: string; href?: string }[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const defaultItems: { label: string; href?: string }[] = [
    { label: '首页', href: '/' },
  ];

  if (pathSegments[0] === 'category' && pathSegments[1]) {
    const cat = categories.find((c) => c.slug === pathSegments[1]);
    defaultItems.push({ label: cat?.name || '分类', href: `/category/${pathSegments[1]}` });
  } else if (pathSegments[0] === 'article' && pathSegments[1]) {
    defaultItems.push({ label: '文章详情' });
  } else if (pathSegments[0] === 'about') {
    defaultItems.push({ label: '关于我们' });
  }

  const breadcrumbItems = items || defaultItems;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbItems.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://www.liujiaoqin.com${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <nav aria-label="面包屑导航" className="w-full px-4 md:px-6">
        <ol className="max-w-7xl mx-auto flex items-center gap-2 py-3 text-xs text-foreground-500 flex-wrap">
          {breadcrumbItems.map((item, index) => (
            <li key={index} className="flex items-center gap-2">
              {index > 0 && (
                <span className="text-foreground-400" aria-hidden="true">/</span>
              )}
              {item.href ? (
                <Link to={item.href} className="hover:text-primary-500 transition-colors whitespace-nowrap">
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-800 font-medium">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}